import frMessages from './fr.json' with { type: 'json' };
import enMessages from './en.json' with { type: 'json' };
export const defaultLocale = 'fr';
export const supportedLocales = ['fr', 'en'];
const fr = frMessages;
const en = enMessages;
let activeLocale = defaultLocale;
const localeSubscribers = new Set();
export function getActiveLocale() {
    return activeLocale;
}
export function setActiveLocale(locale) {
    if (activeLocale === locale)
        return;
    activeLocale = locale;
    for (const subscriber of localeSubscribers) {
        subscriber();
    }
}
export function subscribeLocale(listener) {
    localeSubscribers.add(listener);
    return () => {
        localeSubscribers.delete(listener);
    };
}
export function normalizeLocale(locale) {
    if (locale?.toLowerCase().startsWith('en') === true) {
        return 'en';
    }
    return 'fr';
}
export function translate(key, localeOrValues = activeLocale, maybeValues = {}) {
    const locale = typeof localeOrValues === 'string' ? localeOrValues : activeLocale;
    const values = typeof localeOrValues === 'string' ? maybeValues : localeOrValues;
    const template = locale === 'en' ? (en[key] ?? fr[key]) : fr[key];
    return template.replace(/\{([A-Za-z0-9_]+)\}/gu, (match, valueKey) => values[valueKey] === undefined ? match : String(values[valueKey]));
}
export function hasMessageKey(key) {
    return Object.hasOwn(fr, key);
}
const xofFormats = {
    en: new Intl.NumberFormat('en-US', {
        maximumFractionDigits: 0,
        minimumFractionDigits: 0,
    }),
    fr: new Intl.NumberFormat('fr-FR', {
        maximumFractionDigits: 0,
        minimumFractionDigits: 0,
    }),
};
export function formatXof(amountMinor, locale = activeLocale) {
    const amount = typeof amountMinor === 'bigint' ? Number(amountMinor) : amountMinor;
    const formatted = xofFormats[locale].format(amount).replace(/\s/g, ' ');
    return `${formatted} XOF`;
}
export function formatVisitDate(value, locale = activeLocale) {
    const date = typeof value === 'string' ? new Date(value) : value;
    return new Intl.DateTimeFormat(locale === 'fr' ? 'fr-TG' : 'en-TG', {
        day: 'numeric',
        month: 'long',
        weekday: 'long',
    }).format(date);
}
//# sourceMappingURL=index.js.map